import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fileName: []
};

const downloadStatusSlice = createSlice({
  name: "download",
  initialState,
  reducers: {
    start(state, { payload }) {
      state.fileName.push(payload.file);
    },
    stop(state, { payload }) {
      state.fileName = state.fileName.filter((x) => x !== payload.file);
    },
  },
});

export const { start, stop } = downloadStatusSlice.actions;
export default downloadStatusSlice.reducer;